import React from 'react'
import {useStyles, VideoProgressSlider} from "./ScoredSceneSummarySlider.css";
import moment from "moment";
import {Tooltip} from "@mui/material";
import {useIntl} from "react-intl";

const ScoredSceneSummarySlider = ({scoredScene, timeFormat, challengedDecision = null}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    /*
    Marks to be shown on the slider timeline in the table (score summary)
     */
    const getScoreMarks = () => {
        // Create marks
        const marks = [
            {
                value: scoredScene.basics.sceneStart,
                label: <div className={classes.startEndMark}>{0}</div>
            },
            {
                value: scoredScene.basics.sceneEnd,
                label: <div
                    className={classes.startEndMark}>{moment((scoredScene.basics.sceneEnd - scoredScene.basics.sceneStart) * 1000).format(timeFormat)}</div>
            },
            ...scoredScene.scoreDefinitions.map((s, index) => {
                return {
                    value: s.time,
                    label: getScoreLabel(s, index)
                }
            })
        ]

        // Extend marks in case of duplicates (otherwise they will be overwritten and only one of them will be displayed)
        const extendedMarks = []
        marks.forEach((mark) => {
            const alreadyIncludedMark = extendedMarks.find((m) => m.value === mark.value)

            if (!alreadyIncludedMark) {
                extendedMarks.push(mark)
            } else {
                alreadyIncludedMark.label = <div>
                    <div>{alreadyIncludedMark.label}</div>
                    <div style={{marginTop: 12}}>{mark.label}</div>
                </div>
            }
        })

        return extendedMarks;
    }

    const getScoreLabel = (scoreDefinition, index) => {
        return <Tooltip placement="bottom" classes={{tooltip: classes.noMaxWidth}} title={<div>
            <div className={classes.tooltipHeader}>
                {intl.formatMessage({
                    id: `app.ids.technique.${scoreDefinition.technique}`,
                    defaultMessage: scoreDefinition.technique
                }) + (scoreDefinition.techniqueFreeText ? `: ${scoreDefinition.techniqueFreeText}` : '')}
            </div>
            <div><img src={scoreDefinition.thumbnails?.size295} alt="Thumbnail of score definition"/></div>
        </div>}>
            <div
                className={getMarkClass(scoreDefinition.athlete, index)}>
                {scoreDefinition.key === challengedDecision?.decisionId
                    // The score definition has been challenged (shown as strike-through)
                    ? <div style={{textDecoration: "line-through"}}>{scoreDefinition.score}</div>

                    // Normal (unchallenged) score definition
                    : scoreDefinition.score}
            </div>
        </Tooltip>
    }

    const getMarkClass = (athlete, index) => {
        if (athlete === 'blue') {
            if (index % 2 === 0) {
                return classes.roundScoreBlueTop
            } else {
                return classes.roundScoreBlueBottom
            }
        } else {
            if (index % 2 === 0) {
                return classes.roundScoreRedTop
            } else {
                return classes.roundScoreRedBottom
            }
        }
    }

    return <VideoProgressSlider valueLabelDisplay="on"
                                valueLabelFormat={(value, index) => ''}
                                min={scoredScene.basics.sceneStart}
                                max={scoredScene.basics.sceneEnd}
                                marks={getScoreMarks(scoredScene)}
    />
}
export default ScoredSceneSummarySlider
